import moment from "moment";
import { getUserGPSAddressAction } from "../store/actions/userAction";
import { env } from "../env";
import {
  LOCALSTORAGE_KEY,
  MINIMUM_PUJA_BOOKING_DATE,
  orderType,
  templeOfferingsMenu,
} from "./Constants";
import { fromBlob } from "image-resize-compress";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
export const uid = function () {
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
};

export const getDateToday = () => {
  return moment().utcOffset("+05:30").format("DD/MM/YYYY");
};

export const getFormattedDate = (date: any) => {
  return moment(date).utcOffset("+05:30").format("DD/MM/YYYY");
};
export const getFormattedDateTime = (date: any) => {
  if (date && date.length > 0) {
    return moment(date).utcOffset("+05:30").format("DD/MM/YYYY HH:mm");
  } else {
    return "";
  }
};

export const getNormalizedDateTime = (date: any) => {
  if (date && date.length > 0) {
    return moment(date, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm");
  } else {
    return "";
  }
};
export const removeTimeFromOrderDate = (date: any) => {
  return moment(date, "YYYY-MM-DD h:mmA").format("DD-MM-YYYY");
};
export const getDateNowInUtc = () =>
  moment().utc().format("YYYY-MM-DDTHH:mm:ss[Z]");

export const getDateNowInUtcWithFormate = (str: string) =>
  moment().utc().format(str);

export const getOneImageForTemple = (imageArr: any) => {
  if (imageArr.length > 0) {
    let imageTemple = imageArr[0]?.pictureUrl;
    for (let i = 0; i < imageArr?.length; i++) {
      if (imageArr[i]?.isPrimary) {
        imageTemple = imageArr[i]?.pictureUrl;
      }
    }
    return imageTemple;
  } else {
    return "";
  }
};

export const calculateTotalAmountForTemple = (
  basicPrice: any,
  commission: any
) => {
  const price = basicPrice + (basicPrice / 100) * 20 - commission;
  return price.toFixed(2);
};

export const calculateTDS = (basicPrice: any, commission: any) => {
  const tds =
    0.05 * parseFloat(calculateTotalAmountForTemple(basicPrice, commission));
  return tds.toFixed(2);
};

export const calculateActualAmountToPay = (
  basicPrice: any,
  commission: any
) => {
  const templePrice = calculateTotalAmountForTemple(basicPrice, commission);
  const tds = calculateTDS(basicPrice, commission);
  return (parseFloat(templePrice) - parseFloat(tds)).toFixed(2);
};

export const getDateFormatedOrderTime = (timeDate: any) => {
  //return moment(timeDate).format('hh:mm:ss a')

  return moment(timeDate).utc().local().format("DD-MM-YYYY hh:mm a");
};

export const getDateFormatedForBookingDate = (timeDate: any) => {
  //return moment(timeDate).format('hh:mm:ss a')
  // moment(timeDate).format('Do, hh:mm a');
  return moment(timeDate, "YYYY-MM-DD h:mmA").format("DD-MM-YYYY hh:mm a");
};

export const getDateFormatedForPujaDetails = (timeDate: any) => {
  //return moment(timeDate).format('hh:mm:ss a')
  // moment(timeDate).format('Do, hh:mm a');
  return moment(timeDate, "YYYY-MM-DD h:mmA").format("DD-MM-YYYY");
};

export const getCurrentTime = () => {
  //return moment(timeDate).format('hh:mm:ss a')
  // moment(timeDate).format('Do, hh:mm a');
  return moment().format("HH:mm a");
};

export const getCurrentTimeUtc = () => {
  //return moment(timeDate).format('hh:mm:ss a')
  // moment(timeDate).format('Do, hh:mm a');
  return moment().utcOffset("+05:30").format("HH:mm a");
};

export const getCurrentUTCDate = () => {
  return moment().utcOffset("+05:30").format("DD-MM-YYYY");
};

export const getDateFormatedForMUISelection = (timeDate: any) => {
  return moment(timeDate).format("YYYY-MM-DD 10:30A");
};

export const splitCamelCase = (str: string) => {
  // Using regular expression to split camelCase and periods
  return str
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\./g, " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const capitalizeWords = (inputString: string) => {
  const words = inputString?.split("_");
  let capitalizedString = "";
  if (words?.length) {
    capitalizedString = words
      ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      ?.join(" ");
  }

  return capitalizedString;
};

export const formatEmptyValue = (value: string) => {
  return typeof value != "undefined" || value != null || value != ""
    ? String(value)
    : " ";
};

export const filterUniqueUserEvents = (data: any) => {
  if (!data) {
    return data;
  }
  // const uniqueObjects: any = [];
  // const uniqueKeys = new Set();

  // data.forEach((item: any) => {
  //   const key = `${item?.eventData?.userId || item?.data?.user_id}-${item.key}`;
  //   if (!uniqueKeys.has(key)) {
  //     uniqueObjects.push(item);
  //     uniqueKeys.add(key);
  //   }
  // });
  // return uniqueObjects;

  const uniqueObjects = data.reduce((acc: any, obj: any) => {
    const key = `${
      obj?.eventData?.userId ||
      obj?.data?.user_id ||
      obj?.eventData?.whatsAppNumber
    }-${obj?.key}`;

    if (!acc[key]) {
      acc[key] = { count: 1, ...obj };
    } else {
      acc[key].count++;
    }
    return acc;
  }, {});
  const result = Object.values(uniqueObjects);
  return result;
};

export const convertToNormalString = (input: string) => {
  return input
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export const removeFbclid = (url: string) => {
  // Find the index of fbclid in the URL
  const fbclidIndex = url.indexOf("fbclid");

  // If fbclid is found, remove it along with the characters after it
  if (fbclidIndex !== -1) {
    // Find the index of the next parameter separator ('&') after fbclid
    const nextParamIndex = url.indexOf("&", fbclidIndex);
    // If there are no more parameters after fbclid, remove everything from fbclid onwards
    const finalUrl =
      nextParamIndex !== -1
        ? url.slice(0, fbclidIndex)
        : url.slice(0, fbclidIndex - 1);
    return finalUrl;
  }

  // If fbclid is not found, return the original URL
  return url;
};

export const getFormattedTimeForDate = (date: any) => {
  let dateWithTime = moment(date)
    .utcOffset("+05:30")
    .format("DD-MM-YYYY hh:mm A");
  let time = dateWithTime.split(" ")[1] + " " + dateWithTime.split(" ")[2];
  return time;
};

export const getFormattedDateForTithi = (date: any) => {
  return moment(date).utcOffset("+05:30").format("DD/MM/YYYY hh:mm A");
};

export const validatePhoneNumber = (phone: any) => {
  const phoneRegex = /^(\+1|1)?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
  return phoneRegex.test(phone);
};

export const getCurrentPosition = async (dispatch: any) => {
  if (navigator.geolocation) {
    await navigator.geolocation.getCurrentPosition(
      (position: any) => {
        dispatch(
          getUserGPSAddressAction(
            position.coords.latitude,
            position.coords.longitude
          )
        );
      },
      (err: any) => console.log("Error:", err)
    );
  } else {
    navigator.permissions
      .query({ name: "geolocation" })
      .then((permissionStatus) => {
        if (permissionStatus.state === "denied") {
          alert("Please allow location access.");
        } else {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              dispatch(
                getUserGPSAddressAction(
                  position.coords.latitude,
                  position.coords.longitude
                )
              );
              // setPosition({
              //   latitude: position.coords.latitude,
              //   longitude: position.coords.longitude,
              // });
            },
            (err) => console.log("Error:", err)
          );
        }
      });
  }
};

export const generateTransactionId = () => {
  const timestamp = Date.now();
  const randomString = Math.random().toString(36).substring(2, 10); // Generate a random string
  const transactionId = `${timestamp}`;
  return transactionId;
};

export const generateUniqueNumberString = () => {
  const timestamp = new Date().getTime();
  const counter = Math.floor(Math.random() * 1000000);
  const uniqueNumberString = (timestamp + counter)
    .toString()
    .padStart(12, "0")
    .slice(-6);

  return uniqueNumberString;
};

export const createPaymentData = (
  data: any,
  phoneNumber: any,
  transectionId: any,
  orderId: any,
  finalPrice: any,
  key: any
) => {
  const secret = "FTwnPzEXFhfxSeEBrYxPRBBv";
  //const key = 'rzp_test_opDPOTIQs4H8jr';
  var options = {
    description: "Credits towards puja",
    image: "https://imgur.com/a/kA6KAUc",
    currency: "INR",
    key: key,
    amount: finalPrice * 100,
    name: "Temple Dekho",
    email: "appsadmin@omkarainfotech.com",
    order_id: orderId,
    contact: phoneNumber,
    remember_customer: true,
    captured: true,
    transectionId: transectionId,
    notes: {
      address: "Ground Floor, SJR Cyber, Laskar Hosur Road, Bengaluru",
    },
    save: 1,
    method: data.upiId ? "upi" : "card",
    prefill: {
      token_id: "token_N9qey7xk4mRcWH",
      email: "avinash@omkarainfotech.com",
      contact: phoneNumber,
      name: data.holderName,
      method: data.upiId ? "upi" : "card", //'method': 'netbanking', //card|upi|wallet
      save: 1,
      vpa: data.upiId ? data.upiId : "",
      "card[number]": data.cardNo ? data.cardNo : "",
      "card[expiry]": data.expMonth ? `${data.expMonth}/${data.expYear}` : "",
      // 'card[cvv]': '123',
    },
    theme: { color: "#d56939", hide_topbar: true },
  };

  return options;
};

export const PRICES = {
  adminCommission: 20, // value is in percentage
  delivery: 350, // value in amount
  packaging: 50, // value in amount
  goodies: 30, // value in amount
  platformFee: 20, // value is in percentage
  platformFeeForChadhava: 30, // value is in percentage
  gst: 18, // value is in percentage
  gst18: 18,
};

export const calculateAdminCommission = (price: any) => {
  const { adminCommission } = PRICES;
  const commission = (adminCommission / 100) * Number(price);
  return Math.round(commission);
};

export const calculatePlatformFee = (price: any) => {
  const { platformFee } = PRICES;
  const fee = (platformFee / 100) * Number(price);
  return Math.round(fee);
};

export const calculatePlatformFeeForChadhava = (price: any) => {
  const { platformFeeForChadhava } = PRICES;
  const fee = (platformFeeForChadhava / 100) * Number(price);
  return Math.round(fee);
};

export const calculatePujaPaymentPrice = (price: any, couponDiscount: any) => {
  const { delivery, packaging, goodies } = PRICES;
  const total =
    Number(price) -
    Number(couponDiscount) +
    Number(delivery) +
    Number(packaging) +
    Number(goodies) +
    calculateAdminCommission(price) +
    calculatePlatformFee(price);

  // nee to check with legal team about gst calculatiom
  // removing basic price for gst as of now
  const tax = calculateGSTPrice(total, couponDiscount);
  const totalPrice = total + tax;
  return totalPrice;
};

export const calculateActualPujaPrice = (price: any) => {
  const { delivery, packaging, goodies } = PRICES;
  const total =
    Number(price) +
    Number(delivery) +
    Number(packaging) +
    Number(goodies) +
    calculateAdminCommission(price) +
    calculatePlatformFee(price);
  return total;
};

export const calculateGSTPrice = (price: any, couponDiscount: any) => {
  const { gst } = PRICES;
  const total = Number(price) - Number(couponDiscount);
  const tax = (Number(gst) / 100) * total;
  return Math.round(tax);
};

export const generatePanchangPayload = (addressInfo: any, date: any) => {
  //Its based on GPS data || currentAddress || Default value is set to howrah
  return {
    cityName: addressInfo?.address?.city || "Howrah,west bengal",
    config: { ayanamsha: "lahiri", observation_point: "topocentric" },
    date: date,
    hours: 22,
    indianDate: date,
    latitude: addressInfo?.address?.latitude || 22.5707175,
    longitude: addressInfo?.address?.longitude || 88.3214323,
    minutes: 0,
    month: 5,
    seconds: 0,
    timezone: 5.5,
    year: 2024,
  };
};

export const getDateToShow = (date: any) => {
  if (date === 1 || date === 21) {
    return {
      dateNumber: date,
      subText: "st",
    };
  } else if (date === 2 || date === 22) {
    return {
      dateNumber: date,
      subText: "nd",
    };
  } else if (date === 3 || date === 23) {
    return {
      dateNumber: date,
      subText: "rd",
    };
  } else {
    return {
      dateNumber: date,
      subText: "th",
    };
  }
};

export const isMobile = () => {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
};

// Function to get the ordinal suffix for a given day
const getOrdinalSuffix = (day: number): string => {
  if (day > 3 && day < 21) return "th"; // Covers 11th to 20th
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

export const formatDate = (date: string): string => {
  // Specify the date format if it's known
  const format = "DD-MM-YYYY"; // Format of the input date string

  // Parse the date with the specified format
  const momentDate = moment(date, format, true);

  // Check if the date is valid
  if (!momentDate.isValid()) {
    return "";
  }

  const day = momentDate.format("dddd");
  const dateOrdinal = momentDate.format("D");
  const suffix = getOrdinalSuffix(parseInt(dateOrdinal));
  const month = momentDate.format("MMMM");
  const year = momentDate.format("YYYY");

  return `${day}, ${dateOrdinal}${suffix} ${month}, ${year}`;
};

export const convertMinutesToOffset = (minutes: number): string => {
  const sign = minutes >= 0 ? "+" : "-";
  const absMinutes = Math.abs(minutes);
  const hours = Math.floor(absMinutes / 60);
  const mins = absMinutes % 60;
  const formattedHours = String(hours).padStart(2, "0");
  const formattedMinutes = String(mins).padStart(2, "0");
  return `${sign}${formattedHours}:${formattedMinutes}`;
};

export const convertArrayOfObjectsToCSV = (data: any[]): string => {
  if (data.length === 0) return "";

  const headers = Object.keys(data[0]);
  const csv = [
    headers?.map((item) => splitCamelCase(item))?.join(","), // Add headers as the first line
    ...data.map((item) =>
      headers.map((fieldName) => JSON.stringify(item[fieldName])).join(",")
    ),
  ].join("\n");

  return "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
};

//CSV data

export const downloadExcelSheetFromObject = (
  filename: string,
  jsonData: any
) => {
  const csvData = jsonToCSV(jsonData);
  const blob = new Blob([csvData], { type: "text/csv" });
  const a = document.createElement("a");
  a.href = window.URL.createObjectURL(blob);
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

function jsonToCSV(jsonData: any) {
  const headers = [
    "Key",
    "Puja Booking Date",
    "Puja Name",
    "Count",
    "Temple Name",
    "Phone Number",
    "User Id",
    "User Name",
    "Application Type",
    // "WhatsApp Number",
    "Whatsapp Number",
  ];

  //const headers = Object.keys(jsonData[0]);
  const csv = jsonData.map((row: any) =>
    headers.map((fieldName) => JSON.stringify(row[fieldName])).join(",")
  );
  return [headers.join(","), ...csv].join("\n");
}

export function getDevoteeSerial(no: any) {
  switch (no) {
    case 0:
      return "First";
    case 1:
      return "Second";
    case 2:
      return "Third";
    case 3:
      return "Fourth";
    case 4:
      return "Fifth";
    case 5:
      return "Sixth";
    case 6:
      return "Seventh";
    case 7:
      return "Eighth";
    case 8:
      return "Ninth";
    case 9:
      return "Tenth";
    case 10:
      return "Eleventh";
    case 11:
      return "Twelfth";
    case 12:
      return "Thirteenth";
    case 13:
      return "Fourteenth";
    case 14:
      return "Fifteenth";
    case 15:
      return "Sixteenth";
    case 16:
      return "Seventeenth";
    case 17:
      return "Eighteenth";
    case 18:
      return "Nineteenth";
    case 19:
      return "Twentieth";
    default:
      return "First";
  }
}

export const dayNameToNumber = (dayName: string): number | null => {
  const dayMapping: { [key: string]: number } = {
    Sun: 0,
    Mon: 1,
    Tue: 2,
    Wed: 3,
    Thu: 4,
    Fri: 5,
    Sat: 6,
  };

  return dayMapping[dayName] !== undefined ? dayMapping[dayName] : null;
};

export const getAvailableMonth = (datesArray: string[]) => {
  const availableDate = getNextDate(datesArray);
  const { month } = getNextAvailableMonth(availableDate);
  let currentDate = new Date();
  let currentMonth = currentDate.getMonth() + 1;
  return month - currentMonth;
};

// function getNextAvailableMonth(dates:string[]) {
//   let currentDate = new Date();
//   let currentMonth = currentDate.getMonth() + 1;
//   let currentYear = currentDate.getFullYear();
//   while (true) {
//       if (dates?.some((date:any) => {
//           const d = new Date(date);
//           return d.getMonth() + 1 === currentMonth && d.getFullYear() === currentYear;
//       })) {
//           return { month: currentMonth, year: currentYear };
//       }
//       // Increment month and adjust year if necessary
//       currentMonth++;
//       if (currentMonth > 12) {
//           currentMonth = 1;
//           currentYear++;
//       }
//   }
// }

function getNextAvailableMonth(dates: string[]) {
  let currentDate = new Date();
  let currentMonth = currentDate.getMonth() + 1;
  let currentYear = currentDate.getFullYear();
  const filteredList = removePastDates(dates);
  for (let i = 0; i < 3; i++) {
    // Limit search to 3 months ahead
    const tempCurrMonth = currentMonth;
    const tempCurrYear = currentYear;
    if (
      filteredList.some((date: any) => {
        const d = new Date(date);
        return (
          d.getMonth() + 1 === tempCurrMonth && d.getFullYear() === tempCurrYear
        );
      })
    ) {
      return { month: tempCurrMonth, year: tempCurrYear };
    }
    // Increment month and adjust year if necessary
    currentMonth++;
    if (currentMonth > 12) {
      currentMonth = 1;
      currentYear++;
    }
  }
  return { month: 0, year: 0 }; // No available month found within 3 months
}

function getNextDate(datesArray: string[]) {
  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  return datesArray.map((date) => {
    if (daysOfWeek.includes(date)) {
      const targetDay = daysOfWeek.indexOf(date);
      const today = new Date();
      const currentDay = today.getDay();
      const daysUntilNext = (targetDay + 7 - currentDay) % 7 || 7;
      const nextDate = new Date(today);
      nextDate.setDate(today.getDate() + daysUntilNext);
      return nextDate.toDateString();
    } else {
      const specificDate = new Date(date);
      if (isNaN(specificDate.getTime())) {
        return ``;
      }
      return specificDate.toDateString();
    }
  });
}

function getNextDayOfWeek(datesArray: string[]) {
  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  return datesArray.map((date) => {
    if (daysOfWeek.includes(date)) {
      const targetDay = daysOfWeek.indexOf(date);
      const today = new Date();
      const currentDay = today.getDay();
      const daysUntilNext = (targetDay + 7 - currentDay) % 7 || 7;
      const nextDate = new Date(today);
      nextDate.setDate(today.getDate() + daysUntilNext);
      return `Chadhava item not available for date: ${nextDate.toDateString()}`;
    } else {
      const specificDate = new Date(date);
      if (isNaN(specificDate.getTime())) {
        return `Invalid date format: ${date}`;
      }
      return `Chadhava item not available for date: ${specificDate.toDateString()}`;
    }
  });
}

export function calculateChadhavaPrice(basePrice: number) {
  const omkaraCommission = calculatePlatformFeeForChadhava(basePrice);
  const tax = calculateGstValue(omkaraCommission, PRICES.gst18);
  let response: any = {
    basePrice: Math.ceil(basePrice),
    calculatedPrice: Math.ceil(basePrice + omkaraCommission),
    gst: Math.ceil(tax),
    finalPrice: Math.ceil(basePrice + omkaraCommission + tax),
    priceBreakup: {
      // This data is for calculating puja price without tax
      basePrice: Math.ceil(basePrice),
      delivery: 0,
      packaging: 0,
      goodies: 0,
      adminCommission: 0,
      platformFee: Math.ceil(omkaraCommission),
    },
  };

  return response;
}

const calculateGstValue = (price: any, gst = PRICES.gst18) => {
  const pujaPrice = Number(price);
  const tax = (Number(gst) / 100) * pujaPrice;
  return tax;
};

// const calculateReverseBasePriceValue = (price: any, gst = 1.18) => {
//   const pujaPrice = Number(price);
//   const basePrice = pujaPrice / Number(gst);
//   return basePrice;
// };

const calculateReverseBasePriceValue = (price: any, gst = 1.18) => {
  const pujaPrice = Number(price);
  const basePrice = pujaPrice / Number(gst);
  const gstToPay = pujaPrice - basePrice;
  return { _basePrice: basePrice, _gst: gstToPay };
};

export const formatTimestamp = (timestamp: any, format: string) => {
  return moment(timestamp * 1000).format(format);
};

export const getDynamicPdfFileName = (data: any) => {
  const userName = data?.userBirthDetails?.fullName || "User";
  const date = new Date();
  const formattedDate = `${date.getFullYear()}-${
    date.getMonth() + 1
  }-${date.getDate()}_${date.getHours()}-${date.getMinutes()}-${date.getSeconds()}`;

  return `${data?.service}-report_${userName}_${formattedDate}.pdf`;
};

export function logger(...args: any) {
  if (env === "dev") {
    console.log(...args);
  }
}
export const getSplicedDateData = (dateOfBirth: any, dateType: any) => {
  let result = {};
  if (dateType === "date") {
    result = {
      day: dateOfBirth.date(),
      month: dateOfBirth.month() + 1,
      year: dateOfBirth.year(),
    };
  } else if (dateType === "time") {
    result = {
      hour: dateOfBirth.hour(),
      minutes: dateOfBirth.minute(),
    };
  }
  return result;
};

export const formatNumberToString = (num: any) => {
  return num < 10 ? `0${num}` : num;
};

export const getToFixeValue = (value: any, returnType = "string"): any => {
  if (returnType === "string") {
    return value ? Number(value).toFixed(2) : "";
  } else {
    return value ? parseFloat(Number(value).toFixed(2)) : 0.0;
  }
};

export const formatToTwoFractionalDigits = (number: any) => {
  const numStr = number?.toString();
  const [integerPart, fractionalPart = ""] = numStr?.split(".");
  const formattedFractionalPart = fractionalPart?.padEnd(2, "0").slice(0, 2);
  return `${integerPart}.${formattedFractionalPart}`;
};

export const calculateOverSeasPrice = (
  inrPrice: number,
  rate = 1,
  returnType = "string"
): Number => {
  const convertedPrice = getToFixeValue(rate * inrPrice, returnType) || 0.0;
  return convertedPrice;
};

export const getFormattedAddress = (addressDetails: any) => {
  let formatAddress =
    addressDetails?.street +
    " ," +
    addressDetails?.area +
    " ," +
    addressDetails?.city +
    " ," +
    addressDetails?.state +
    " ," +
    addressDetails?.zip +
    " ," +
    addressDetails?.countryCode;
  return formatAddress;
};

export const detectLanguage = (text: any) => {
  const cleanedText = text.replace(/[^a-zA-Z0-9\u0900-\u097F\s]/g, "").trim();
  if (cleanedText.length === 0) return "und";
  const hindiRegex = /[\u0900-\u097F]/;
  const englishRegex = /^[A-Za-z\s]*$/;

  if (hindiRegex.test(cleanedText)) {
    return "HI";
  }
  if (englishRegex.test(cleanedText)) {
    return "EN";
  }
  return "und";
};

export const getRandomNumber = () => {
  return Math.floor(Math.random() * (2000 - 1000 + 1)) + 1000;
};

export const formatNumber = (num: any) => {
  return (num / 1000).toFixed(1) + "k";
};

export const sanitizeQuantity = (quantity: any) => {
  // Ensure quantity is a valid number. If it's NaN, undefined, or null, default to 1.
  const sanitizedQuantity = parseInt(quantity, 10);
  return isNaN(sanitizedQuantity) ? 0 : sanitizedQuantity;
};

export function replaceSpacesWithHyphen(name: any) {
  if (!name) {
    return ""; // Handle empty or null input
  }
  return name
    .trim() // Remove leading/trailing spaces
    .replace(/[^a-zA-Z0-9\s]/g, "") // Remove special characters
    .replace(/\s+/g, "-");
}

// export function calculatePrasadForOnboardingPrice(
//   basePrice: number,
//   isFixedPrice = false
// ) {
//   const _basePrice = calculateReverseBasePriceValue(basePrice, 1.18);
//   const omkaraCommission = isFixedPrice
//     ? 0
//     : calculatePlatformFeeForChadhava(basePrice);
//   const tax = isFixedPrice
//     ? calculateGstValue(_basePrice, PRICES.gst18)
//     : calculateGstValue(omkaraCommission, PRICES.gst18);
//   let response: any = {
//     basePrice: Math.ceil(isFixedPrice ? _basePrice : basePrice),
//     calculatedPrice: Math.ceil(
//       (isFixedPrice ? _basePrice : basePrice) + omkaraCommission
//     ),
//     gst: Math.ceil(tax),
//     finalPrice: Math.ceil(
//       (isFixedPrice ? _basePrice : basePrice) + omkaraCommission + tax
//     ),
//     priceBreakup: {
//       // This data is for calculating puja price without tax
//       basePrice: Math.ceil(isFixedPrice ? _basePrice : basePrice),
//       delivery: 0,
//       packaging: 0,
//       goodies: 0,
//       adminCommission: 0,
//       platformFee: Math.ceil(omkaraCommission),
//     },
//   };

//   return response;
// }

export function calculatePrasadForOnboardingPrice(
  basePrice: number,
  isFixedPrice = false
) {
  const { _basePrice, _gst } = calculateReverseBasePriceValue(basePrice, 1.18);
  const omkaraCommission = isFixedPrice
    ? 0
    : calculatePlatformFeeForChadhava(basePrice);
  const tax = isFixedPrice
    ? calculateGstValue(_basePrice, PRICES.gst18)
    : calculateGstValue(omkaraCommission, PRICES.gst18);
  let response: any = {
    basePrice: Math.ceil(isFixedPrice ? _basePrice : basePrice),
    calculatedPrice: Math.ceil(
      (isFixedPrice ? _basePrice : basePrice) + omkaraCommission
    ),
    gst: Number(tax.toFixed(2)),
    finalPrice: Math.ceil(
      isFixedPrice ? _basePrice + _gst : basePrice + omkaraCommission + tax
    ),
    priceBreakup: {
      // This data is for calculating puja price without tax
      basePrice: Math.ceil(isFixedPrice ? _basePrice : basePrice),
      delivery: 0,
      packaging: 0,
      goodies: 0,
      adminCommission: 0,
      platformFee: Math.ceil(omkaraCommission),
    },
  };

  return response;
}

function extractTimes(scheduleString: any) {
  // Assuming the schedule string follows the pattern "Day: startTime – endTime"
  const [day, timeRange] = scheduleString.split("ay");

  if (!timeRange) {
    console.error("Invalid schedule string format");
    return null;
  }

  // Split the time range into start and end times
  const [startTime, endTime] = timeRange
    .split("–")
    .map((time: any) => time.trim());

  return {
    day: day.trim(),
    startTime,
    endTime,
  };
}

export const getDayNameByNumber = (dayNumber: number) => {
  switch (dayNumber) {
    case 0:
      return "Monday";
    case 1:
      return "Tuesday";
    case 2:
      return "Wednesday";
    case 3:
      return "Thursday";
    case 4:
      return "Friday";
    case 5:
      return "Saturday";
    case 6:
      return "Sunday";
    default:
      return "Monday";
  }
};

export const getSplittedTimeGooglePeriod = (
  googlePeriodData: any,
  existingTiming: any
) => {
  const newData = googlePeriodData.map((item: any, index: number) => {
    let extraxted = extractTimes(item);
    let newValue = {
      id: 0,
      day: "Monday",
      openingTime: "09:00 AM",
      closingTime: "06:00 PM",
    };
    newValue.openingTime = extraxted?.startTime.replace(": ", "");
    newValue.closingTime = extraxted?.endTime;
    newValue.id = index;
    newValue.day = getDayNameByNumber(index);

    return newValue;
  });

  return newData;
};
export const regex =
  /\+(?:998|996|995|994|993|992|977|976|975|974|973|972|971|970|968|967|966|965|964|963|962|961|960|886|880|856|855|853|852|850|692|691|690|689|688|687|686|685|683|682|681|680|679|678|677|676|675|674|673|672|670|599|598|597|595|593|592|591|590|509|508|507|506|505|504|503|502|501|500|423|421|420|389|387|386|385|383|382|381|380|379|378|377|376|375|374|373|372|371|370|359|358|357|356|355|354|353|352|351|350|299|298|297|291|290|269|268|267|266|265|264|263|262|261|260|258|257|256|255|254|253|252|251|250|249|248|246|245|244|243|242|241|240|239|238|237|236|235|234|233|232|231|230|229|228|227|226|225|224|223|222|221|220|218|216|213|212|211|98|95|94|93|92|91|90|86|84|82|81|66|65|64|63|62|61|60|58|57|56|55|54|53|52|51|49|48|47|46|45|44D?1624|44D?1534|44D?1481|44|43|41|40|39|36|34|33|32|31|30|27|20|7|1D?939|1D?876|1D?869|1D?868|1D?849|1D?829|1D?809|1D?787|1D?784|1D?767|1D?758|1D?721|1D?684|1D?671|1D?670|1D?664|1D?649|1D?473|1D?441|1D?345|1D?340|1D?284|1D?268|1D?264|1D?246|1D?242|1)D?/gm;

export const removeCountryCode = (textString: any) => {
  return textString.replace(regex, "");
};

export const formatNumberWithK = (num: number) => {
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + "k";
  }
  return num.toString();
};

// get formatted delivary address for order
export function getFormattedAddressForDelivary(
  street: any,
  area: any,
  city: any,
  state: any,
  zip: any,
  countryCode: any
) {
  let formattedAddress = "";
  if (street && street.length > 0) {
    formattedAddress = street;
  }
  if (area && area.length > 0) {
    formattedAddress =
      formattedAddress.length > 0 ? `${formattedAddress}, ${area}` : area;
  }
  if (city && city.length > 0) {
    formattedAddress =
      formattedAddress.length > 0 ? `${formattedAddress}, ${city}` : city;
  }
  if (state && state.length > 0) {
    formattedAddress =
      formattedAddress.length > 0 ? `${formattedAddress}, ${state}` : state;
  }
  if (zip && zip.length > 0) {
    formattedAddress =
      formattedAddress.length > 0 ? `${formattedAddress}, ${zip}` : zip;
  }
  if (countryCode && countryCode.length > 0) {
    formattedAddress =
      formattedAddress.length > 0
        ? `${formattedAddress}, ${countryCode}`
        : countryCode;
  }

  return formattedAddress;
}
export const isValidDate = (dateString: any) => {
  const date = new Date(dateString);
  return !isNaN(date.getTime());
};

export const getNearestValidDate = (
  datesArray: (string | Date)[] = [],
  minimum_puja_day = MINIMUM_PUJA_BOOKING_DATE
): Date | null => {
  if (!Array.isArray(datesArray)) {
    console.error("Invalid input: datesArray should be an array.");
    return null;
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const minBookingDate = new Date(today);
  minBookingDate.setDate(today.getDate() + minimum_puja_day);
  const convertedDates = datesArray.map((item) => {
    if (typeof item === "string" && isNaN(Date.parse(item))) {
      const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      const targetDay = daysOfWeek.indexOf(item);

      const date = new Date(today);
      date.setDate(date.getDate() + minimum_puja_day);
      while (date.getDay() !== targetDay) {
        date.setDate(date.getDate() + 1);
      }
      return date;
    } else {
      return new Date(item);
    }
  });
  const validDates = convertedDates.filter((date) => date >= minBookingDate);
  validDates.sort((a, b) => a.getTime() - b.getTime());
  return validDates.length > 0 ? validDates[0] : null;
};

export const isDateWithinNextTwoDays = (
  date: any,
  minimum_puja_day = MINIMUM_PUJA_BOOKING_DATE
) => {
  const givenDate = new Date(date);
  const today = new Date();
  const twoDaysAgo = new Date();

  twoDaysAgo.setDate(today.getDate() + minimum_puja_day);
  givenDate.setHours(0, 0, 0, 0);
  twoDaysAgo.setHours(0, 0, 0, 0);


  return givenDate >= twoDaysAgo;
};

export const removePastDatesByNameAndDate = (
  days: any,
  minimum_puja_day = MINIMUM_PUJA_BOOKING_DATE
) => {
  const today = new Date();
  const minAllowedDate = new Date();
  minAllowedDate.setDate(today.getDate() + minimum_puja_day);
  minAllowedDate.setHours(0, 0, 0, 0); // Normalize to midnight

  // If days array is undefined, null, or empty, return [today + minimum_puja_day] in YYYY-MM-DD format
  if (!days || days.length === 0) {
    return [
      `${minAllowedDate.getFullYear()}-${String(
        minAllowedDate.getMonth() + 1
      ).padStart(2, "0")}-${String(minAllowedDate.getDate()).padStart(2, "0")}`,
    ];
  }

  // Function to check if a value is a valid date string (YYYY-MM-DD format)
  const isDateString = (day: any) => /^\d{4}-\d{2}-\d{2}$/.test(day);

  // Weekday mapping
  const weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  // Helper: get upcoming date for a given weekday string
  const getUpcomingDate = (weekday: any) => {
    const targetIndex = weekDays.indexOf(weekday);
    let daysUntilTarget = (targetIndex - today.getDay() + 7) % 7;
    if (daysUntilTarget === 0) {
      daysUntilTarget = 7;
    }
    let upcoming = new Date(today);
    upcoming.setDate(today.getDate() + daysUntilTarget);
    upcoming.setHours(0, 0, 0, 0);

    if (upcoming < minAllowedDate) {
      upcoming.setDate(upcoming.getDate() + 7);
    }
    return upcoming;
  };

  // Build an array of objects for each valid day (either a date string or a weekday)
  const futureItems = days
    .map((item: any) => {
      if (isDateString(item)) {
        const date = new Date(item);
        date.setHours(0, 0, 0, 0);
        return date >= minAllowedDate
          ? { type: "date", value: date, original: item }
          : null;
      } else if (weekDays.includes(item)) {
        // if (item === weekDays[today.getDay()]) {
        //   return null;
        // }
        const upcoming = getUpcomingDate(item);
        return upcoming >= minAllowedDate
          ? { type: "day", value: upcoming, original: item }
          : null;
      }
      return null;
    })
    .filter(Boolean);

  // Sort the items by their upcoming date value
  futureItems.sort((a: any, b: any) => a.value - b.value);

  // Return the original string values in sorted order
  return futureItems.map((entry: any) => entry.original);
};

export const getUpcomingDate = (
  dayName: string,
  minimum_puja_day = MINIMUM_PUJA_BOOKING_DATE
) => {
  if (!dayName || dayName === "undefined" || dayName === "null") {
    return "";
  }
  // Check if input is a valid date format (YYYY-MM-DD)
  const dateFormat = /^\d{4}-\d{2}-\d{2}$/;

  if (dateFormat.test(dayName)) {
    // Return the same date if input is already in date format
    const inputDate = new Date(dayName);

    // Calculate the date that is MINIMUM_PUJA_BOOKING_DATE days greater than today
    const today = new Date();
    const twoDaysLater = new Date(today);
    twoDaysLater.setDate(today.getDate() + minimum_puja_day);
    twoDaysLater.setHours(0, 0, 0, 0);

    // If the input date is at least MINIMUM_PUJA_BOOKING_DATE days greater than today, return the input date
    if (inputDate >= twoDaysLater) {
      // console.log('getUpcomingDate', dayName);
      return dayName;
    }

    return "";
  }

  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  // Convert the short day name to a number (0 for Sunday, 1 for Monday, ..., 6 for Saturday)
  const dayIndex = daysOfWeek.indexOf(dayName);

  if (dayIndex === -1) {
    // console.log("Invalid day name", dayName);
    // throw new Error(
    //   "Invalid day name. Use 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', or 'Sun'."
    // );
    return "";
  }

  const today = new Date();
  const todayIndex = today.getDay();

  // Calculate days to add to get to the next occurrence of the desired day
  let daysToAdd = (dayIndex + 7 - todayIndex) % 7 || 7;

  // Ensure the upcoming date is at least 2 days from today
  if (daysToAdd < minimum_puja_day) {
    daysToAdd += 7; // Add 7 to ensure it's at least the next week's occurrence
  }

  // Calculate the upcoming date
  const upcomingDate = new Date(today);
  upcomingDate.setDate(today.getDate() + daysToAdd);

  // Format the upcoming date as "YYYY-MM-DD"
  const year = upcomingDate.getFullYear();
  const month = String(upcomingDate.getMonth() + 1).padStart(2, "0");
  const day = String(upcomingDate.getDate()).padStart(2, "0");
  console.log("day", `${year}-${month}-${day}`);

  return `${year}-${month}-${day}`;
};

export const displayDateFormat = (
  dateString: string,
  fromFormat = "YYYY-MM-DD"
) => {
  return moment(dateString, fromFormat).format("MMMM D, YYYY");
};

export function getImageListFromTemple(
  templePersonalInfo: any,
  type: any = "pictures"
) {
  let templeMediaList: any = [];

  if (
    templePersonalInfo &&
    templePersonalInfo?.media &&
    templePersonalInfo?.media?.[type] &&
    templePersonalInfo?.media?.[type]?.length > 0
  ) {
    templeMediaList = [...templePersonalInfo.media?.[type]];
  } else if (
    templePersonalInfo &&
    templePersonalInfo?.media &&
    templePersonalInfo?.media?.pictures &&
    templePersonalInfo?.media?.pictures?.length > 0
  ) {
    templeMediaList = [...templePersonalInfo.media.pictures];
  }
  return templeMediaList;
}
//templeName
export const getTempleName = (templeInfoData: any, langCode: string) => {
  if (templeInfoData && templeInfoData?.personalInfo) {
    if (
      templeInfoData?.personalInfo?.templeName &&
      Object.keys(templeInfoData?.personalInfo?.templeName ?? {}).length
    ) {
      return templeInfoData?.personalInfo?.templeName[langCode];
    } else {
      return templeInfoData?.personalInfo?.name;
    }
  } else {
    return "";
  }
};

export const getConcatenatedTempleNames = (
  templeList: Record<string, any>
): string => {
  const langCode = localStorage.getItem(LOCALSTORAGE_KEY.LANG_CODE) ?? "en";

  if (!templeList || typeof templeList !== "object") {
    return "";
  }

  return Object.values(templeList)
    .map((temple: any) => {
      if (
        temple?.personalInfo?.templeName &&
        Object.keys(temple.personalInfo.templeName).length
      ) {
        return (
          temple.personalInfo.templeName[langCode] ||
          temple.personalInfo.name ||
          ""
        );
      }
      return temple?.personalInfo?.name || "";
    })
    .filter((name) => !!name)
    .join(", ");
};

export const getDayNameFromShortName = (coming: any) => {
  // Check if all days of the week are present in the coming array
  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const comingArray = Array.isArray(coming)
    ? coming
    : coming.split(", ").map((day: any) => day.trim());

  const allDaysAvailable = daysOfWeek.every((day: any) =>
    comingArray.includes(day)
  );

  if (allDaysAvailable) {
    return "Throughout the week";
  } else {
    // If not all days are present, list out the full names of the days
    const fullNames = comingArray.map((day: any) => {
      switch (day) {
        case "Sun":
          return "Sunday";
        case "Mon":
          return "Monday";
        case "Tue":
          return "Tuesday";
        case "Wed":
          return "Wednesday";
        case "Thu":
          return "Thursday";
        case "Fri":
          return "Friday";
        case "Sat":
          return "Saturday";
        default:
          return day;
      }
    });
    return fullNames && fullNames.length > 4
      ? "Multiple dates"
      : fullNames.join(", ");
  }
};

export const formatRestrictionDates = (dates: string[]) => {
  return dates
    .map((date) => {
      if (date.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const formattedDate = new Date(date).toLocaleDateString("en-GB"); // converts to "DD/MM/YYYY"
        return formattedDate;
      }
      return date;
    })
    .join(", ");
};

export const getMinimumPriceDataForChadhava = (chadhavaBookingsOnly: any) => {
  let minBookingChadhavaPriceIND =
    chadhavaBookingsOnly?.templeDetails?.minBookingChadhavaPriceIND || 50;
  let minBookingChadhavaPriceOverseas =
    chadhavaBookingsOnly?.templeDetails?.minBookingChadhavaPriceOverseas || 1;

  return { minBookingChadhavaPriceIND, minBookingChadhavaPriceOverseas };
};

export const delay = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));
export const truncateToTwoDecimals = (amount: any): any => {
  const parsedAmount = parseFloat(amount);

  if (isNaN(parsedAmount)) {
    return 0;
  }

  return Math.trunc(parsedAmount * 100) / 100;
};
export const getCityStateFromTemple = (templePersonalInfo: any) => {
  if (!templePersonalInfo || !templePersonalInfo.address) {
    return "";
  }
  const { city, state } = templePersonalInfo.address;
  if (city && state) {
    return `${city}, ${state}`;
  } else if (city) {
    return city;
  } else if (state) {
    return state;
  } else {
    return "";
  }
};

export const getUTCIndiaTimeNow = (): string => {
  const todayDate = moment()
    .utcOffset("+05:30")
    .format("YYYY-MM-DDTHH:mm:ss[Z]");
  return todayDate;
};

export async function reduceImageFile(
  file: any,
  quality = 50,
  maxWidth = 0,
  maxHeight = 0
) {
  try {
    const format = "webp";
    const imageBitmap = await createImageBitmap(file);
    const width = maxWidth > 0 ? maxWidth : imageBitmap.width;
    const height = maxHeight > 0 ? maxHeight : imageBitmap.height;

    const reducedBlob = await fromBlob(file, quality, width, height, format);

    const reducedFile = new File(
      [reducedBlob],
      file.name.replace(/\.\w+$/, ".webp"),
      {
        type: "image/webp",
        lastModified: Date.now(),
      }
    );
    return reducedFile;
  } catch (error) {
    console.error("Image reduction failed:", error);
    throw error;
  }
}

export const getDateFromDayjs = (date: any) => {
  return moment(dayjs(date, "YYYY-MM-DDTHH:mm:ss[Z]").toString()).format(
    "DD-MM-YYYY"
  );
};

export const getDayjsFromDate = (date: any) => {
  return dayjs(date ?? undefined, "DD-MM-YYYY");
};

export const getItemType = (cartItem: any) => {
  // console.log("Item data",cartItem)
  if (cartItem && cartItem?.orderType === orderType.puja) {
    return cartItem?.pujaDetails?.pujaName;
  } else if (cartItem?.orderType === orderType.chadhava) {
    return "Chadhava";
  } else if (cartItem?.orderType === orderType.prasad) {
    return "Prasad";
  }
  return "";
};
export const removePastDates = (datesArr: string[]) => {
  const today = new Date();
  const threshold = new Date(today);
  threshold.setDate(today.getDate() + MINIMUM_PUJA_BOOKING_DATE);
  threshold.setHours(0, 0, 0, 0);

  const filteredDates = datesArr.filter((dateStr: any) => {
    const date = new Date(dateStr);
    date.setHours(0, 0, 0, 0);
    return date >= threshold;
  });
  return filteredDates;
};

export const getUpcomingDatesForDays = (days: any) => {
  const startDate = moment();
  const endDate = moment().add(3, "months");

  const specificDates = new Set<string>();
  const weekdaySet = new Set<string>();
  const normalizedDays = Array.isArray(days) ? days : [days];

  // Separate weekdays and specific dates
  normalizedDays.forEach((item: any) => {
    const lower = item.toLowerCase?.() || ""; // handle non-string values safely
    if (["sun", "mon", "tue", "wed", "thu", "fri", "sat"].includes(lower)) {
      weekdaySet.add(lower);
    } else if (moment(item, "YYYY-MM-DD", true).isValid()) {
      specificDates.add(moment(item).format("YYYY-MM-DD"));
    }
  });

  const result: Set<string> = new Set();
  const current = startDate.clone();

  while (current.isSameOrBefore(endDate, "day")) {
    const formatted = current.format("YYYY-MM-DD");
    const weekday = current.format("ddd").toLowerCase();

    if (weekdaySet.has(weekday)) {
      result.add(formatted);
    }

    if (specificDates.has(formatted)) {
      result.add(formatted);
    }

    current.add(1, "day");
  }

  return Array.from(result).sort(); // sorted result
};

export function updateMetaTagsAtClientEnd({
  title,
  description,
  imageUri,
}: any): void {
  // Update document title
  document.title = title;

  // Update <meta name="description">
  const descTag = document.querySelector('meta[name="description"]');
  if (descTag instanceof HTMLMetaElement) {
    descTag.content = description;
  }

  // Update <meta property="og:image">
  const imageTag = document.querySelector('meta[property="og:image"]');
  if (imageTag instanceof HTMLMetaElement) {
    imageTag.content = imageUri;
  }
}

export const getOverSeasPriceByRateText = (
  inrPrice: number,
  orderTypeOfItem: any,
  currencySymbols: any,
  rate: any = 1,
  isToConvertPrice = false
) => {
  if (orderTypeOfItem === orderType.prasad) {
    return `₹ ${inrPrice}`;
  }
  return `${currencySymbols}${
    isToConvertPrice ? inrPrice : calculateOverSeasPrice(inrPrice, rate)
  }`;
};

export function toUTCISOString(
  date?: string | Date | dayjs.Dayjs | null
): string | null {
  if (!date) return null;

  const d = dayjs(date);
  if (!d.isValid()) return null;

  return d.utc().toISOString();
}

export const getMaxAllowedMember = (multiPujaList: any) => {
  let sortedMultiPujaList: any = [];
  sortedMultiPujaList = [...multiPujaList]?.sort(
    (a: any, b: any) =>
      sanitizeQuantity(a?.maxMemberAllowed) -
      sanitizeQuantity(b?.maxMemberAllowed)
  );

  return sortedMultiPujaList && sortedMultiPujaList?.length > 0
    ? sortedMultiPujaList[sortedMultiPujaList?.length - 1]?.maxMemberAllowed
    : 1;
};

export const getMinimumPrice = (packages: any[]) => {
  if (!packages || packages.length === 0) return 0;
  return Math.min(...packages.map((pkg) => pkg?.priceInfo?.finalPrice || 0));
};

export const getUserName = (user: any) => {
  if (!user?.personalInfo) return null;

  const firstName = user.personalInfo?.firstName || "";
  const lastName = user.personalInfo?.lastName || "";

  const fullName = `${firstName} ${lastName}`.trim();

  return fullName || null;
};

export function getDeviceInfo() {
  return {
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    language: navigator.language,
    vendor: navigator.vendor,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    colorDepth: window.screen.colorDepth,
    deviceType: navigator.userAgent,
  };
}

export function mergeOverlayStyle(defaultStyle: any, dbStyle: any = {}) {
  const merged = { ...defaultStyle, ...dbStyle };

  if ("top" in dbStyle) delete merged.bottom;
  if ("bottom" in dbStyle) delete merged.top;
  if ("left" in dbStyle) delete merged.right;
  if ("right" in dbStyle) delete merged.left;

  return merged;
}
export const hasValue = (v: unknown) =>
  (typeof v === "string" && v.trim().length > 0) ||
  (typeof v === "number" && !isNaN(v));

export const normalizePhoneNumber = (phoneNumber: string) => {
  if (phoneNumber.startsWith("+")) {
    return phoneNumber.slice(1);
  }
  return phoneNumber;
};

export const getTempleNameById = (
  templeList: Record<string, any>,
  templeId: string
): string => {
  const savedLanguage =
    localStorage.getItem(LOCALSTORAGE_KEY.LANG_CODE) ?? "en";
  const templeInfo = templeList?.[templeId];
  return getTempleName(templeInfo, savedLanguage);
};

export const generateOrderId = (orderTypeValue: string): string => {
  switch (orderTypeValue) {
    case orderType.puja:
      return `PO${generateUniqueNumberString()}`;
    case orderType.chadhava:
      return `CO${generateUniqueNumberString()}`;
    case orderType.prasad:
      return `PRO${generateUniqueNumberString()}`;
    case orderType.pujaPackage:
      return `PSO${generateUniqueNumberString()}`;
    case orderType.chadhavaPackage:
      return `CSO${generateUniqueNumberString()}`;
    default:
      return `PO${generateUniqueNumberString()}`;
  }
};

export const getOfferPriceFromV1 = (
  _priceBreakupV1: any,
  isOverseas: boolean = false,
  isPrsad: boolean = false,
  rate: number = 1
) => {
  if (!_priceBreakupV1) return 0;
  const countryPriceData = isOverseas
    ? _priceBreakupV1?.overseas
    : _priceBreakupV1?.india;
  if (!countryPriceData) return 0;
  const priceDataWithOrWithoutPrasad = isPrsad
    ? countryPriceData?.pujaWithPrasad
    : countryPriceData?.pujaWithoutPrasad;
  if (!priceDataWithOrWithoutPrasad?.offerActualPrice) return 0;
  return isOverseas
    ? truncateToTwoDecimals(
        (priceDataWithOrWithoutPrasad?.offerActualPrice ?? 0) * rate
      )
    : priceDataWithOrWithoutPrasad.offerActualPrice;
};

export const getAllTempleNamesForPackage = (templeList: any = {}) => {
  if (!templeList || typeof templeList !== "object") return "";
  const temples: any = Object.values(templeList);
  const templesWithPuja: any = temples?.filter(
    (t: any) =>
      (t?.templePuja && t?.templePuja?.length > 0) ||
      (t?.templeChadhava && t?.templeChadhava.length > 0)
  );
  const names = templesWithPuja
    .map((t: any) => t?.personalInfo?.name)
    .filter(Boolean);
  return names.join(", ");
};

export const extractFullApiUrl = (storageUrl: any) => {
  try {
    const url = new URL(storageUrl);
    return url.pathname.substring(1) + url.search;
  } catch (e) {
    console.error("Invalid URL format:", e);
    return null;
  }
};

export const checkIfChadhavaDisabled = (_restrictionDate: any): boolean => {
  if (_restrictionDate?.length < 1) return true;
  const daysOfWeek = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  const todayPlusTwo = moment().add(2, "days").startOf("day");
  for (const item of _restrictionDate) {
    // includes days , than chadhava is valid
    if (daysOfWeek.includes(item)) {
      return false;
    }
    const parsedDate = moment(item, "YYYY-MM-DD", true);
    // if date is valid and after today + 2 days, than chadhava is valid
    if (parsedDate.isValid() && parsedDate.isAfter(todayPlusTwo)) {
      return false;
    }
  }
  // chadhava is disabled
  return true;
};

export const handleMarkerPress = (latitude: any, longitude: any) => {
  const url = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
  window.open(url, "_blank"); 
};


export const isSubscriptionAvailable = (data: any) => {
  if (!data) return false;

  const templeEnabled = data.isSubscriptionEnabled === true;
  const hasSubscriptions =
    Array.isArray(data.subscriptions) && data.subscriptions.length > 0;
  const anySubscriptionEnabled = data.subscriptions?.some(
    (item: any) => item?.isSubscriptionEnabled === true
  );

  return templeEnabled && hasSubscriptions && anySubscriptionEnabled;
};

export const getFilteredChadhavaSubsList = (cdList: any, idList: any) => {
  if (!Array.isArray(cdList) || !Array.isArray(idList)) return [];

  return cdList.filter((item) => idList.includes(item?.id));
};

export const getExcludedChadhavaSubsList = (cdList: any, idList: any) => {
  if (!Array.isArray(cdList) || !Array.isArray(idList)) return [];

  return cdList.filter((item) => !idList.includes(item?.id));
};


export const calculateDiscountedPrice = (
  price: number,
  discountPercent: number
) => {
  if (!price) return 0;
  if (!discountPercent) return price;

  const discountAmount = (price * discountPercent) / 100;

  const finalPrice = price - discountAmount;

  return finalPrice < 0 ? 0 : finalPrice;
};

export const getTotalChadhavaSubscriptionPrices = (
  items: any[],
  frequency: number | string = 1,
  fixDiscount: number | string = 0
) => {
  const totals = items.reduce(
    (acc, curr) => {
      const count = curr?.count ?? 0;
      if (!count) return acc;

      acc.totalFinalPrice += curr.priceInfo.finalPrice * count;
      acc.totalFinalPriceOv += (curr.priceInfo.finalPriceOv ?? 0) * count;

      return acc;
    },
    {
      totalFinalPrice: 0,
      totalFinalPriceOv: 0,
    }
  );

  const count = Number(frequency) ?? 0;

  // original × frequency
  const subscriptionOfferPrice = (
    totals.totalFinalPrice * count
  );

  const subscriptionOfferPriceOv = (
    totals.totalFinalPriceOv * count
  );

  // apply percent discount
  const subscriptionPrice = (calculateDiscountedPrice(
    subscriptionOfferPrice,
    Number(fixDiscount)
  ));

  const subscriptionPriceOv = (calculateDiscountedPrice(
    subscriptionOfferPriceOv,
    Number(fixDiscount)
  ));

  return {
    // original totals
    totalFinalPrice: totals.totalFinalPrice,
    totalFinalPriceOv: totals.totalFinalPriceOv,
    // multiplied totals
    subscriptionOfferPrice,
    subscriptionOfferPriceOv,
    // discounted totals
    subscriptionPrice,
    subscriptionPriceOv,
  };
};

export const calculateChadhavaPriceDataForSubscription = (
  selectedChadhvaList: any[],
  frequency: number | string = 1,
) => {
  const totalPrices = selectedChadhvaList?.reduce(
    (totals: any, item: any) => {
      const multiplier = (item?.count ?? 0) * (Number(frequency) ?? 0);
      const finalPrice = Number(item.priceInfo.finalPrice) * multiplier;
      const calculatedPrice = Number(item.priceInfo.calculatedPrice) * multiplier;
      const basePrice = Number(item.priceInfo.basePrice) * multiplier;
      const gst = Number(item.priceInfo.gst) * multiplier;
      const platformFee = item.priceInfo.priceBreakup.platformFee
        ? Number(item.priceInfo.priceBreakup.platformFee) * multiplier
        : 0;
      const adminCommission = item.priceInfo.priceBreakup.adminCommission
        ? Number(item.priceInfo.priceBreakup.adminCommission) * multiplier
        : 0;

      const finalPriceOv = Number(
        multiplier * Number(item?.priceInfo?.finalPriceOv)
      ).toFixed(2);

      totals.finalPriceTotal += finalPrice;
      totals.calculatedPriceTotal += calculatedPrice;
      totals.gstTotal += gst;
      totals.basePrice += basePrice;
      totals.platformFee += platformFee;
      totals.adminCommission += adminCommission;

      totals.finalPriceOv += Number(finalPriceOv);

      return totals;
    },
    {
      finalPriceTotal: 0,
      calculatedPriceTotal: 0,
      gstTotal: 0,
      basePrice: 0,
      platformFee: 0,
      adminCommission: 0,
      finalPriceOv: 0,
    }
  );

  const priceData = {
    actualPujaPrice: totalPrices?.calculatedPriceTotal,
    delivery: 0,
    gst: totalPrices?.gstTotal?.toFixed(2) || 0,
    finalPrice:
      Number(totalPrices?.finalPriceTotal)  || 0,
    calculatedPrice: totalPrices?.calculatedPriceTotal || 0,
     finalPriceOv:
        Number(
          totalPrices?.finalPriceOv 
      ) || 0,
    chadhavaValueItemFinalOv: Number(totalPrices?.finalPriceOv?.toFixed(2)),
    chadhavaValueItemFinal: Number(totalPrices?.finalPriceTotal?.toFixed(2)),
    priceBreakup: {
      basePrice: Number(totalPrices?.basePrice) || 0,
      delivery: 0,
      packaging: 0,
      goodies: 0,
      adminCommission: Number(totalPrices?.adminCommission) || 0,
      platformFee: Number(totalPrices?.platformFee) || 0,
      dakshina:0,
    },
  };
  return priceData;
};


type PriceObject = Record<string, any>;

export function scaleObjectValues(obj: PriceObject, frequency: number = 1): PriceObject {
  if (frequency === 1) return { ...obj };

  const newObj: PriceObject = {};

  for (const key in obj) {
    const val = obj[key];

    // Case A: It's a real Number
    if (typeof val === "number") {
      newObj[key] = val * frequency;
    }
    // Case B: It's a String that looks like a number ("99")
    else if (typeof val === "string" && !isNaN(Number(val)) && val.trim() !== "") {
      // FIX: Use parseFloat() or Number() instead of 'as number'
      newObj[key] = parseFloat(val) * frequency; 
    }
    // Case C: It's a nested Object (recurse)
    else if (typeof val === "object" && val !== null) {
      newObj[key] = scaleObjectValues(val, frequency);
    }
    // Case D: It's text, boolean, or something else (keep as is)
    else {
      newObj[key] = val;
    }
  }

  return newObj;
}


export const isOfferingVisible = (
  itemType: string,
  templeDetails: any
): boolean => {
  if (!templeDetails) return false;

  if (itemType === "puja") {
    const isClosedBooking = templeDetails?.isClosedBooking ?? true;
    const templePujaList = templeDetails?.templePuja || [];

    const hasActivePuja = templePujaList.some(
      (puja: any) => puja?.isPujaDisable === false
    );

    return !isClosedBooking && hasActivePuja;
  }

  if (itemType === "chadhava") {
    return templeDetails?.isChadhavaEnabled ?? false;
  }

  if (itemType === "prasad") {
    return templeDetails?.isPrasadEnabled ?? false;
  }

  return false;
};

export const hasAnyOfferingVisible = (
  offeringsMenu: any[],
  templeDetails: any
): boolean => {
  if (!offeringsMenu?.length) return false;

  return offeringsMenu.some((item) =>
    isOfferingVisible(item?.type, templeDetails)
  );
};
